// extracted by mini-css-extract-plugin
export var category = "_h3-9";
export var categoryHeader = "_h3-e";
export var container = "_h3-0";
export var group = "_h3-a";
export var groupItems = "_h3-f";
export var groupSeparator = "_h3-j";
export var loading = "_h3-1";
export var noResults = "_h3-3";
export var placeholder = "_h3-2";
export var resultContent = "_h3-5";
export var resultIcon = "_h3-c";
export var resultItem = "_h3-g";
export var resultMeta = "_h3-8";
export var resultSubtitle = "_h3-7";
export var resultSuffix = "_h3-i";
export var resultTitle = "_h3-6";
export var resultsList = "_h3-4";
export var searchGroup = "_h3-d";
export var selected = "_h3-h";
export var subgroup = "_h3-b";